import type { GatewayBrowserClient } from "../gateway.ts";

export type SystemOverviewPlugin = {
  id: string;
  name: string;
  version?: string;
  description?: string;
  kind?: string;
  source: string;
  origin: "bundled" | "global" | "workspace" | "config";
  status: "loaded" | "disabled" | "error";
  error?: string;
  enabled: boolean;
  toolNames: string[];
  channelIds: string[];
  providerIds: string[];
  gatewayMethods: string[];
  services: string[];
  configSchema: boolean;
};

export type SystemOverviewTool = {
  pluginId: string;
  names: string[];
  optional: boolean;
  source: string;
};

export type SystemOverviewConfigSection = {
  section: string;
  title?: string;
  description?: string;
};

export type SystemOverviewData = {
  plugins: SystemOverviewPlugin[];
  tools: SystemOverviewTool[];
  configSections: SystemOverviewConfigSection[];
};

export type SystemOverviewState = {
  client: GatewayBrowserClient | null;
  connected: boolean;
  systemOverviewLoading: boolean;
  systemOverviewData: SystemOverviewData | null;
  systemOverviewError: string | null;
  systemOverviewSubView: SystemOverviewSubView;
};

export type SystemOverviewSubView =
  | "tools-system"
  | "tools-config"
  | "plugins-system"
  | "plugins-config"
  | "config-schema";

export const SYSTEM_OVERVIEW_SUBVIEWS: Array<{
  value: SystemOverviewSubView;
  label: string;
}> = [
  { value: "tools-system", label: "Tools — Built-in" },
  { value: "tools-config", label: "Tools — Config Required" },
  { value: "plugins-system", label: "Plugins — System" },
  { value: "plugins-config", label: "Plugins — Config Required" },
  { value: "config-schema", label: "Config Schema" },
];

export async function loadSystemOverview(state: SystemOverviewState) {
  if (!state.client || !state.connected) {
    return;
  }
  if (state.systemOverviewLoading) {
    return;
  }
  state.systemOverviewLoading = true;
  state.systemOverviewError = null;
  try {
    const res = await state.client.request<SystemOverviewData>("system.overview", {});
    state.systemOverviewData = res;
  } catch (err) {
    state.systemOverviewError = String(err);
  } finally {
    state.systemOverviewLoading = false;
  }
}
